import { render } from "./contents.vue?vue&type=template&id=a2c36268&scoped=true"
import script from "./contents.vue?vue&type=script&lang=js"
export * from "./contents.vue?vue&type=script&lang=js"

import "./contents.vue?vue&type=style&index=0&id=a2c36268&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c36268"]])

export default __exports__